var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 52.2",
    enableBackground: "new 0 0 48 52.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M23.2,42.6c-1.4,0-2.5-1.1-2.5-2.5v-35c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v35 C25.7,41.5,24.5,42.6,23.2,42.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M34.6,16c-0.6,0-1.3-0.2-1.8-0.7L23.6,6l-9.2,9.3c-1,1-2.6,1-3.5,0c-1-1-1-2.6,0-3.5l11-11.1 c0.9-0.9,2.6-0.9,3.6,0l11,11.1c1,1,1,2.6,0,3.5C35.8,15.8,35.2,16,34.6,16z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M40.4,52.2H7.7c-4,0-7.2-3.2-7.2-7.2v-4.8c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v4.8c0,1.2,1,2.2,2.2,2.2 h32.8c1.2,0,2.2-1,2.2-2.2v-4.8c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v4.8C47.7,48.9,44.4,52.2,40.4,52.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/_upload.1d70b032cd645691577bff76ccb7297c.svg";
export { ForwardRef as ReactComponent };